import React, { useEffect } from 'react';
import '../../css/login.css';
import { useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import GifIconLoading from '../../assets/gif/mainLoading.gif';
import { useMediaQuery } from 'react-responsive';

function Login() {

    const isMobile = useMediaQuery({ query: '(min-width: 767px)' })

    const { result, error } = useMsalAuthentication(InteractionType.Redirect, {
        scopes: ["openid"],
    });

    return (
        <div className='mainViewContainerLogin'>
            <img src={GifIconLoading} alt="gif" className={ isMobile ? 'mainGifContainerLogin' : 'mainGifContainerLoginMobile' } />
        </div>
    )
}

export default Login